import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import ebook from '../../components/assets/ebook.jpg';
import starapple from '../../components/assets/starapple.jpg';

const galleryImages = [
  {
    url: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/85204786_107561057510674_4264176473591513088_n.jpg?stp=c0.54.1080.1080a_dst-jpg_s206x206_tt6&_nc_cat=107&ccb=1-7&_nc_sid=50ad20&_nc_ohc=ruH3surFDxsQ7kNvwEKdTSj&_nc_oc=Adn-dOaE7NfjfoSIEKj-AEuparUJylmUVdPRPTd4HJUsvIqm934DQQnhcK4g8RXSEn0&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=47VorRMZk2nfhxCXK71hMQ&oh=00_AfGVDfOgGZy7StfZYFTwzDS0ykvVzCcimN8hh7u7A7VG0w&oe=682DE109',
    title: 'Nigerian Crayfish',
    category: 'Products'
  },
  {
    url: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/106028455_157115605888552_2268793343311700381_n.jpg?stp=c0.139.540.540a_dst-jpg_s206x206_tt6&_nc_cat=103&ccb=1-7&_nc_sid=50ad20&_nc_ohc=ozJnosSHkGIQ7kNvwGbFBUW&_nc_oc=AdkGeCZ6EZSKQMFuXgdrF3yqv34b9Y0n0lVM4ipAoIzMCpsePe1bl76vjrZ6vh5z03k&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=rB5ooExI6z5ue79KbUfWEw&oh=00_AfEim41pT8sFsYzH3HsHdeIj7gWvG-nCbXQwWtSK8tK4uQ&oe=682DE51C',
    title: 'Export Grade Smoked Catfish',
    category: 'Products'
  },
  {
    url: starapple,
    title: 'African Star Apple',
    category: 'Products'
  },
  {
    url: ebook,
    title: 'FREE Ebook',
    category: 'Products'
  },
  {
    url: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/107247877_159685275631585_8691152873654441561_n.jpg?stp=c297.0.486.486a_dst-jpg_s206x206_tt6&_nc_cat=105&ccb=1-7&_nc_sid=50ad20&_nc_ohc=D8XqDqfHINIQ7kNvwHh0anG&_nc_oc=AdlfRS95dnyOP3cdcG0KiAjTh3sikvz8dyGG9T9vAs76hOlfEj_zZ6fEeDrZYkILu7s&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=K6lf31poVe5ADxA2qaLuFQ&oh=00_AfG3onwcSIwC1XXMvOA823QydVKK6AG2bZXFibR37EwnJw&oe=682E07B2',
    title: 'Masterclass Session 2020',
    category: 'Events'
  },
  {
    url: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/106927896_159685228964923_3469884147093546028_n.jpg?stp=c221.0.486.486a_dst-jpg_s206x206_tt6&_nc_cat=102&ccb=1-7&_nc_sid=50ad20&_nc_ohc=IAaGZs5qSR0Q7kNvwHzS85s&_nc_oc=Adlco-JHCms2sAs83OpAfT_Y-eVOrgrJwDnpgmF64zeeec-yxoxbBq_OnkDzI5W-DA0&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=RjKeu_Yyjs9-f1d9Fl7yYg&oh=00_AfH4xjdzF1gUe31_V7nfxU_aLP37__gQzt1eSdOA7K6CAw&oe=682DF021',
    title: 'Export Development Centre',
    category: 'Events'
  },
  {
    url: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/138802291_236013171332128_8369467969123030328_n.jpg?stp=c120.0.720.720a_dst-jpg_s206x206_tt6&_nc_cat=105&ccb=1-7&_nc_sid=50ad20&_nc_ohc=EZlFWFA2BogQ7kNvwF2PxsL&_nc_oc=AdkL0On5zMC75WnxnrRuZe2NohobDXtYiS6B84jFluaCS0e6HbuPzO1Ul9LbyQfriJE&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=tuvKm8G7BObkucVd_WHB1g&oh=00_AfGyBR754SK8O0r1QjcRHVSvPslJlB5GPAPIAMMeSktpMw&oe=682DD911',
    title: 'Masterclass Session 2021',
    category: 'Events'
  },
  {
    url: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/108220639_162188328714613_2484005622266445111_n.jpg?stp=c121.0.719.719a_dst-jpg_s206x206_tt6&_nc_cat=111&ccb=1-7&_nc_sid=50ad20&_nc_ohc=hNMBMxdBtGcQ7kNvwFazQnf&_nc_oc=AdnP7a4ZvNXv7b0kHJlxN7zX7VIGHx75zTRO3WJ1_mz5biXSrq47p8SEH2iXK9CG3q4&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=JfzRy54jDVVRcGGInYlcqw&oh=00_AfGhGcQbI_2MSosRfvkPeZATn5_IZMm5Se6sI4jBneyWSg&oe=682DFA84',
    title: 'Business Networking',
    category: 'Events'
  }
];

const FEMGallery = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [filter, setFilter] = useState<'all' | 'Products' | 'Events'>('all');

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            Gallery
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-xl text-gray-600"
          >
            Explore our products and past masterclass moments
          </motion.p>
        </div>

        <div className="flex justify-center gap-4 mb-8">
          {['all', 'Products', 'Events'].map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category as typeof filter)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
                filter === category
                  ? 'bg-green-600 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {filteredImages.map((image, index) => (
            <motion.div
              key={image.url}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative group cursor-pointer"
              onClick={() => setSelectedImage(image.url)}
            >
              <div className="aspect-w-3 aspect-h-2 overflow-hidden rounded-lg">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="text-white text-center p-4">
                    <p className="text-lg font-semibold">{image.title}</p>
                    <p className="text-sm">{image.category}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Lightbox */}
        {selectedImage && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center p-4">
            <div className="relative max-w-4xl w-full">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute -top-12 right-0 text-white hover:text-gray-300"
              >
                <X className="h-8 w-8" />
              </button>
              <img
                src={selectedImage}
                alt="Selected"
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default FEMGallery;